import script from "./BelongsToField.vue?vue&type=script&setup=true&lang=js"
export * from "./BelongsToField.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/nginx/domains/tools.androidrepublic.org/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"BelongsToField.vue"]])

export default __exports__